var exports = {
  "kb": "x31de4314--d711af--left",
  "pG": "x31de4314--d711af--right",
  "Qs": "x31de4314--d711af--content",
};

module.exports = exports;
